import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingStateService } from '../services/loading-state.service';

@Injectable()
export class LoadingStateInterceptor implements HttpInterceptor {
  private readonly loadingState = inject(LoadingStateService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loadingState.requestStarted(req.url);

    return next.handle(req).pipe(
      finalize(() => {
        this.loadingState.requestCompleted(req.url);
      })
    );
  }
}
